import Fraud from './Fraud';

export default Fraud;
